import { DirectiveOptions } from 'vue';

import HMDialog from '@/web/components/common/HMDialog.vue';

const confirmDirective: DirectiveOptions = {
  inserted(el: any, binding, vnode: any) {
    el.listener = function (event) {
      event.stopPropagation();
      const { title, subtitle, text, confirmButton, confirm } = binding.value;

      vnode.context.$modal.show(HMDialog, {
        title,
        subtitle,
        text,
        confirmButton,
        confirm,
      });
    };
    el.addEventListener('click', el.listener);
  },
};

export default confirmDirective;
